export const DEFAULT_STATE = {
  addNewFaqData: {},
  faqListData: {},
  deleteFaqData: {},
  logoutTabCloseData: {}
};
